import { EditableDateRangeValue, LabelValue } from '@retail/components';
import dayjs from 'dayjs';
import React from 'react';
import { useCampaignTFunction } from '@retail/campaign/i18n';

interface Props {
  onSave?: (validFrom: Date, validTo: Date) => void;
  validFrom: Date;
  validTo: Date;
}

export const CampaignPeriod = ({ validFrom, validTo, onSave }: Props) => {
  const t = useCampaignTFunction();

  return (
    <LabelValue
      label={t('campaign.campaignPeriod')}
      value={
        <EditableDateRangeValue
          editable={!!onSave}
          renderValue={() => `${dayjs(validFrom).format('ll')} - ${dayjs(validTo).format('ll')}`}
          onSave={({ startDate, endDate }) => onSave && onSave(startDate, endDate)}
          defaultValue={{ startDate: validFrom, endDate: validTo }}
        />
      }
      orientation="vertical"
      spacing={0.5}
    />
  );
};
